import React from 'react';

import { func, number, object } from 'prop-types';
import styled from 'styled-components';

import { Component as ByoCTAs } from '../ByoCTAs';
import { Component as ByoOptionsModal } from '../ByoOptionsModal';

const ByoCTAContainer = styled.div`
  margin-bottom: 20px;
`;

export default function ProductDetailByoOptions({
  checkSizes,
  handleItemErrors,
  product,
  selectedProductQuantity,
  sizeProduct,
}) {
  const checkByoErrorState = () => {
    const itemsWithErrors = checkSizes();
    if (itemsWithErrors.length) {
      handleItemErrors(itemsWithErrors);
    }
    return !!itemsWithErrors.length;
  };

  return (
    <ByoCTAContainer>
      <ByoCTAs
        checkByoErrorState={checkByoErrorState}
        masterProduct={product}
        productToAdd={sizeProduct}
        selectedProductQuantity={selectedProductQuantity}
      />
      <ByoOptionsModal masterProduct={product} productToAdd={sizeProduct} />
    </ByoCTAContainer>
  );
}

ProductDetailByoOptions.propTypes = {
  checkSizes: func,
  handleItemErrors: func,
  product: object,
  selectedProductQuantity: number,
  sizeProduct: object,
};
